export default __webpack_public_path__ + "static/media/github.42c4a06d.png";